import React from 'react';

import WelcomeCard from './WelcomeCard'

export default function WelcomePage(props) {

    return (
        <WelcomeCard/>
    );
}